import React from 'react';
import ReactDOM from 'react-dom/client';
import { UserProvider } from './context/UserContext';
import { BrowserRouter } from 'react-router-dom';
import "./index.css"
import App from './App';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
   <UserProvider>
      <BrowserRouter basename={""}>
         <App />
      </BrowserRouter>
   </UserProvider>
);
